import { gql } from '@apollo/client';

export const fetchQuotesForTransactionAccount = gql`
  query fetchQuotesForTransactionAccount(
    $searchOptions: ConnectionSearchOptions
    $filterOptions: FilterOption
    $fetchLineItems: Boolean = false
  ) {
    quotes(searchOptions: $searchOptions, filterOptions: $filterOptions) {
      totalCount
      nodes {
        id
        status
        quoteNumber
        name
        quoteContact
        quoteAuthor
        billingGroupId
        revisionNumber
        updatedBy
        createdDate
        expiryDate
        updatedDate
        estimateComputedAt
        total
        currency
        poNumber
        billToObject {
          companyName
        }
        shipToObject {
          id
          displayName
          addressLine1
          addressLine2
          city
          country
          postalCode
          state
        }
        createdBy {
          subject
        }
        updatedByObject {
          subject
        }
        metadata {
          quoteContact
          ecc_aaids
        }
        staleReason {
          code
          name
          lastUpdatedDate
        }
        estimateLineItems {
          discountDetails {
            promotionId
            discountAmount
            percentOff
            reasonCode
            discountType
          }
          margins: marginDetails {
            promotionId
            amount
            percent
            reasonCode
            type
            promoCode
          }
        }
        lineItems @include(if: $fetchLineItems) {
          offerings {
            pricingType
          }
        }
      }
    }
  }
`;
